<!-- <ion-header [translucent]="false" class="ion-no-border ion-padding">
  <div class="modal-header">
    <button class="close-btn" (click)="close()">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>
</ion-header> -->
<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="modal-content-div">

     <!-- Configuration status indicator -->
      <div *ngIf="isConfigNotSaved" class="saved-indicator saved-indicator-warning">
        <ion-icon src="assets/icons/not_saved_dot.svg"></ion-icon>
        <span>{{ 'configuration_not_saved' | translate }}</span>
      </div>

      <div *ngIf="isConfigHasUnsavedChanges" class="saved-indicator saved-indicator-danger">
        <ion-icon name="ellipse"></ion-icon>
        <span>{{ 'config_has_unsaved_changes' | translate }}</span>
      </div>

      <div *ngIf="isConfigSaved" class="saved-indicator saved-indicator-success">
        <ion-icon src="assets/icons/green-dot-icon.svg"></ion-icon>
        <span>{{ 'configuration_saved' | translate }}</span>
      </div>
    <div class="config-summary">
      <h3>{{ getConfigurationSummary() }}</h3>
    </div>

    <ion-list lines="none" class="circle-icon-list">
      <!-- Button 1 -->
      <ion-item button detail="false" class="list-button" (click)="onDeleteConfiguration()" [ngClass]="!isSavedProject ? 'disabled' : ''">
        <div class="button-content">
          <span class="button-text">{{'delete_configuration' | translate}}</span>
          <ion-icon src="assets/icons/delete.svg" class="circle-icon" color="danger"></ion-icon>
        </div>
      </ion-item>

      <!-- Button 2 -->
      <ion-item button detail="false" class="list-button" (click)="onRestartConfiguration()">
        <div class="button-content">
          <span class="button-text">{{'restart_configuration' | translate}}</span>
          <ion-icon src="assets/icons/restart.svg" class="circle-icon" color="primary"></ion-icon>
        </div>
      </ion-item>

      <!-- Button 3 -->
      <ion-item button detail="false" class="list-button" (click)="onRenameConfiguration()">
        <div class="button-content">
          <span class="button-text">{{'rename_configuration' | translate}}</span>
          <ion-icon src="assets/icons/edit_pencil.svg" class="circle-icon" color="primary"></ion-icon>
        </div>
      </ion-item>

      <ion-item button detail="false" class="list-button" (click)="onEditConfiguration()">
        <div class="button-content">
          <span class="button-text">{{'edit_configuration' | translate}}</span>
          <ion-icon src="assets/icons/edit_config.svg" class="circle-icon" color="primary"></ion-icon>
        </div>
      </ion-item>

      <!-- <ion-item button detail="false" class="list-button" (click)="onCalculatePerformances()">
      <div class="button-content">
        <span class="button-text">{{'calculate_performances' | translate}}</span>
        <ion-icon name="calculator-outline" class="circle-icon" color="primary"></ion-icon>
      </div>
    </ion-item> -->

      <!-- Button 5 -->
      <ion-item button detail="false" class="list-button" (click)="onDownloadPDF()">
        <div class="button-content">
          <span class="button-text">{{'download_pdf' | translate}}</span>
          <ion-icon src="assets/icons/download.svg" class="circle-icon" color="primary"></ion-icon>
        </div>
      </ion-item>

      <!-- Button 6 -->
      <ion-item button detail="false" class="list-button" (click)="onSaveConfiguration()">
        <div class="button-content">
          <span class="button-text">{{'save_configuration' | translate}}</span>
          <ion-icon *ngIf="isOpenedFromCalculations" src="assets/icons/save_white.svg" class="circle-icon active" color="primary"></ion-icon>
          <ion-icon *ngIf="isOpenedFromConfiguration" src="assets/icons/save_green.svg" class="circle-icon" color="primary"></ion-icon>
        </div>
      </ion-item>

      <ion-item *ngIf="isOpenedFromConfiguration" button detail="false" class="list-button" (click)="onCalculateResults()">
        <div class="button-content">
          <span class="button-text">{{'calculate_results' | translate}}</span>
          <ion-icon src="assets/icons/calculate_white.svg" class="circle-icon active" color="primary"></ion-icon>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>